import React, { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { dateIntoYYYY_MM_DD } from '../../../utils/dateTimeConverter';
import { urlApi } from '../../../api/url.api';
import { postApi } from '../../../api/call.api';

const GoogleAdsPlatformGraph = ({ date, selectedGoogleAccount }) => {
    const [series, setSeries] = useState([{
        name: "Amount Spent",
        data: []
    }, {
        name: "Clicks",
        data: []
    }, {
        name: "Conversion",
        data: []
    }, {
        name: "Interactions",
        data: []
    },
    ]);

    const [options, setOptions] = useState({
        chart: {
            type: 'area',
            toolbar: {
                show: false
            }, zoom: {
                enabled: false,
                allowMouseWheelZoom: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        }, fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 1,
                opacityTo: 0,
                gradientToColors: ["transparent"],
                stops: [0, 100]
            }
        },
        colors: ['#0075FF', '#15BC00', '#9747FF', '#F15A24', '#2CD9FF'],
        xaxis: {
            type: 'datetime',
            categories: [],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                },
                formatter: (value) => {
                    return value?.toFixed(0)
                },
            }
        },
        tooltip: {

        },
        legend: {
            labels: {
                show: true,
            }
        },
        grid: {
            strokeDashArray: 6,
            column: {
                colors: undefined,
                opacity: 0.1
            },
        }
    })

    async function getGraphData() {
        let postData = {
            googleAdsClientId: selectedGoogleAccount?.googleAdsClientId
        }
        if (date?.startDate) {
            postData.startDate = dateIntoYYYY_MM_DD(date.startDate);
            postData.endDate = dateIntoYYYY_MM_DD(date.endDate);
        }
        let url = `${urlApi.getGoogleAdsGraphData}`;
        let resp = await postApi(postData, url);
        if (resp.responseCode === 200) {
            const nameToKeyMap = {
                "Amount Spent": "totalSpend",
                "Clicks": "totalClicks",
                "Conversion": "totalConversion",
                "Interactions": "totalInteractions",
            };
            const dates = resp?.data?.map(item => item.date);
            const updatedSeries = series.map(seriesItem => {
                const key = nameToKeyMap[seriesItem.name];
                return {
                    ...seriesItem,
                    data: resp?.data?.map(stat => stat[key])
                };
            });
            setSeries(updatedSeries);
            setOptions(prevOptions => ({
                ...prevOptions,
                xaxis: { ...prevOptions.xaxis, categories: dates }
            }));
        } else {
            setSeries([{
                name: "Amount Spent",
                data: []
            }, {
                name: "Clicks",
                data: []
            }, {
                name: "Conversion",
                data: []
            }, {
                name: "Interactions",
                data: []
            },
            ]);
            setOptions(prevOptions => ({
                ...prevOptions,
                xaxis: { ...prevOptions.xaxis, categories: [] }
            }));
        }
    }

    useEffect(() => {
        getGraphData();
        return () => {

        };
    }, [date, selectedGoogleAccount]);

    return (
        <div className='global-gradient p-1.5 rounded-xl text-white h-full'>
            <div className="flex justify-between items-center p-1 gap-2">
                <p className='mb-0 text-sm font-medium'>Graph</p>
                <div className='flex ms-auto gap-2'>
                    {/* <div className='text-xs font-medium mb-0 bg-[var(--primary)] px-2 py-0.5 rounded-md'>Attriva</div>
                    <p className='text-xs font-medium mb-0 bg-[var(--deselect-btn-bg)] px-2 py-0.5 rounded-md'>Meta</p> */}
                </div>
            </div>
            <Chart options={options} series={series} height={350} type="area" />
        </div>
    )
}

export default GoogleAdsPlatformGraph
